import { useEffect, useRef, useState } from 'react';

/**
 * The width of the element the returned ref is put on, kept up to date as it is resized (by the
 * window, or by the side panel opening and closing). 0 until it has been measured - and where
 * ResizeObserver does not exist - so a caller treats "unknown" as "roomy".
 */
export const useElementWidth = <T extends HTMLElement>() => {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el || typeof ResizeObserver === 'undefined') return undefined;

    const observer = new ResizeObserver(([entry]) => setWidth(Math.round(entry.contentRect.width)));
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return { ref, width };
};
